import type { WhereOption } from './types.js';

export const PROJECT_TYPE_OPTIONS: readonly WhereOption[] = [
  { value: 'single_building', label: 'Single building' },
  { value: 'master_plan', label: 'Master plan' },
  { value: 'phased_development', label: 'Phased development' },
];

export const PARKING_TYPE_OPTIONS: readonly WhereOption[] = [
  { value: 'garage', label: 'Garage' },
  { value: 'underground', label: 'Underground' },
  { value: 'surface', label: 'Surface' },
];

/** `attribute_tags` values with the `structure_` prefix, shown without it. */
export const STRUCTURE_OPTIONS: readonly WhereOption[] = [
  { value: 'wood_frame', label: 'Wood frame' },
  { value: 'podium', label: 'Podium' },
  { value: 'steel', label: 'Steel' },
  { value: 'concrete', label: 'Concrete' },
  { value: 'mass_timber', label: 'Mass timber' },
  { value: 'masonry', label: 'Masonry' },
  { value: 'modular', label: 'Modular' },
];

/** `regulatory_flags` values as stored. */
export const REVIEW_PATH_OPTIONS: readonly WhereOption[] = [
  { value: 'special_permit', label: 'Special permit' },
  { value: 'site_plan_review', label: 'Site plan review' },
  { value: 'variance', label: 'Variance' },
  { value: 'large_project_review', label: 'Large project review' },
  { value: 'small_project_review', label: 'Small project review' },
  { value: 'boston_article_80', label: 'Boston Article 80' },
  { value: 'cambridge_special_permit', label: 'Cambridge special permit' },
  { value: 'chapter_40b', label: 'Chapter 40B' },
  { value: 'pud', label: 'Planned unit development' },
  { value: 'design_review', label: 'Design review' },
  { value: 'wetlands_notice_of_intent', label: 'Wetlands notice of intent' },
];

export const ENRICHMENT_OPTIONS: readonly WhereOption[] = [
  { value: 'enriched', label: 'Enriched' },
  { value: 'partial', label: 'Partial' },
  { value: 'unenriched', label: 'Not enriched yet' },
  { value: 'stale', label: 'Out of date' },
];

export const UNLOCKED_OPTIONS: readonly WhereOption[] = [
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Phone' },
  { value: 'profile', label: 'Profile' },
];
